module.exports = __webpack_public_path__ + "static/media/toplog.b6c81414.jpg";